import React from 'react';
import { useGetPatientGenderCountQuery } from 'store';
import { Pie } from 'react-chartjs-2';
import {
  Box,
  Text,
  useColorModeValue,
  Spinner,
  Flex
} from '@chakra-ui/react';

const GenderDistributionChart = () => {
    const { data: chartData, isFetching, error } = useGetPatientGenderCountQuery();

    const backgroundColor = useColorModeValue(['#FF6384', '#36A2EB'], ['#FF6384', '#36A2EB']);
    const data = {
        labels: chartData?.map(item => item.sex === 'M' ? 'Male' : 'Female'),
        datasets: [{
            data: chartData?.map(item => item.count),
            backgroundColor,
            hoverBackgroundColor: ['#FF6384', '#36A2EB'],
            cutout: '50%',
        }]
    };

    const total = chartData?.reduce((acc, curr) => acc + curr.count, 0);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.5,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
              callbacks: {
                  label: function(tooltipItem) {
                      let label = tooltipItem.label || '';
                      if (label) {
                          label += ': ';
                      }
                      const currentCount = tooltipItem.raw;
                      const percentage = ((currentCount/total)*100).toFixed(2) + '%';
                      label += `${currentCount} (${percentage})`;
                      return label;
                  }
              }
          }
        }
    };

    return (
        <Box p="4" bg={useColorModeValue('white', 'gray.700')} borderRadius="lg" boxShadow="md">
            <Text fontSize="xl" fontWeight="bold" mb="4">Gender Distribution</Text>
            {isFetching ? (
                <Flex justify="center" align="center" h="200px">
                    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                </Flex>
            ) : error ? (
                <Text color="red.500">Error: {error.message}</Text>
            ) : (
                <Pie data={data} options={options} />
            )}
        </Box>
    );
};

export default GenderDistributionChart;
